/**
 * Admin MESAS: CRUD, grid y vista de productos por mesa.
 */

function posknMesasAdminAjaxUrl(win) {
	return (
		win.ajaxurl ||
		(win.POSKN_API_CONFIG && win.POSKN_API_CONFIG.ajaxUrl) ||
		'pos-ajax.php'
	);
}

function posknMesasAdminNonce(win) {
	return win.posNonce || (win.POSKN_API_CONFIG && win.POSKN_API_CONFIG.posNonce) || '';
}

function posknMesasTiendaId(win) {
	// Principal usa id 0: no usar checks truthy sobre .id
	if (win.posknTiendaSeleccionada && win.posknTiendaSeleccionada.id != null && win.posknTiendaSeleccionada.id !== '') {
		const n = parseInt(win.posknTiendaSeleccionada.id, 10);
		return Number.isNaN(n) ? 0 : n;
	}
	if (win.posknUserTienda && win.posknUserTienda.id != null && win.posknUserTienda.id !== '') {
		const n = parseInt(win.posknUserTienda.id, 10);
		return Number.isNaN(n) ? 0 : n;
	}
	return 0;
}

function initMesasAdminEvents(win, $) {
	if (win._posknMesasAdminBound) return;
	win._posknMesasAdminBound = true;

	$(document).on('submit', '#form-mesa', function onSubmitFormMesa(e) {
		e.preventDefault();
		e.stopPropagation();

		const id = $('#mesa-id').val();
		const numero = $('#mesa-numero').val();
		const nombre = $('#mesa-nombre').val();
		const capacidad = $('#mesa-capacidad').val();

		if (!numero || String(numero).trim() === '') {
			win.mostrarNotificacion('El número de mesa es requerido', 'error');
			return false;
		}

		const action = id ? 'poskn_actualizar_mesa' : 'poskn_crear_mesa';
		const data = {
			action,
			nonce: posknMesasAdminNonce(win),
			numero: String(numero).trim(),
			nombre: nombre ? String(nombre).trim() : '',
			capacidad: capacidad || 4,
			tienda_id: posknMesasTiendaId(win),
		};
		if (id) data.id = id;

		const $submitBtn = $(this).find('button[type="submit"]');
		const originalText = $submitBtn.text();
		$submitBtn.prop('disabled', true).text('Guardando...');

		$.ajax({
			url: posknMesasAdminAjaxUrl(win),
			type: 'POST',
			data,
			dataType: 'json',
			success(response) {
				$submitBtn.prop('disabled', false).text(originalText);
				if (response && response.success) {
					const message =
						(response.data && response.data.message) || 'Mesa guardada exitosamente';
					win.mostrarNotificacion(message, 'success');
					win.cerrarModalMesa();
					if ($('#modulo-mesas').is(':visible')) {
						win.cargarMesas();
					}
					const md = win.mesasData || (win.mesasData = []);
					md.splice(0, md.length);
				} else {
					const errorMsg =
						(response && response.data && response.data.message) || 'Error desconocido';
					win.mostrarNotificacion(errorMsg, 'error');
				}
			},
			error(xhr, status, error) {
				$submitBtn.prop('disabled', false).text(originalText);
				let errorMsg = `Error de conexión: ${error}`;
				if (xhr.responseText) {
					try {
						const errorResponse = JSON.parse(xhr.responseText);
						if (errorResponse.data && errorResponse.data.message) {
							errorMsg = errorResponse.data.message;
						}
					} catch (err) {
						/* ignore parse */
					}
				}
				win.mostrarNotificacion(errorMsg, 'error');
			},
		});

		return false;
	});
}

export function attachMesasAdminGlobals(win, $) {
	win.mesasData = win.mesasData || [];
	initMesasAdminEvents(win, $);

	win.cargarMesas = function cargarMesas() {
		$.ajax({
			url: posknMesasAdminAjaxUrl(win),
			type: 'POST',
			data: {
				action: 'poskn_get_mesas',
				nonce: posknMesasAdminNonce(win),
				tienda_id: posknMesasTiendaId(win),
				live: 1,
			},
			success(response) {
				if (response.success) {
					const md = win.mesasData || (win.mesasData = []);
					md.splice(0, md.length, ...(response.data.mesas || []));
					win.renderizarMesas();
				} else {
					win.mostrarNotificacion(`Error al cargar mesas: ${response.data.message}`, 'error');
				}
			},
			error() {
				win.mostrarNotificacion('Error de conexión al cargar mesas', 'error');
			},
		});
	};

	win.renderizarMesas = function renderizarMesas() {
		const mesasGrid = $('#mesas-grid');
		const mesasData = win.mesasData || [];

		if (!mesasData.length) {
			mesasGrid.html(
				'<div class="no-mesas">No hay mesas configuradas. Crea una nueva mesa para comenzar.</div>',
			);
			return;
		}

		let html = '';
		mesasData.forEach((mesa) => {
			const estadoClass = mesa.estado === 'ocupada' ? 'mesa-ocupada' : 'mesa-libre';
			const estadoText = mesa.estado === 'ocupada' ? 'OCUPADA' : 'LIBRE';
			const nombre = mesa.nombre ? `<div class="mesa-nombre">${mesa.nombre}</div>` : '';
			const numeroSafe = String(mesa.numero || '').replace(/'/g, "\\'");

			html += `
                    <div class="mesa-card ${estadoClass}" data-mesa-id="${mesa.id}" data-mesa-numero="${mesa.numero}">
                        <div class="mesa-numero">${mesa.numero}</div>
                        ${nombre}
                        <div class="mesa-capacidad">👥 ${mesa.capacidad}</div>
                        <div class="mesa-estado">${estadoText}</div>
                        <div class="mesa-acciones">
                            ${
								mesa.estado === 'ocupada'
									? `<button class="btn-ver-mesa" onclick="verProductosMesa(${mesa.id}, ${mesa.order_id || 0}, '${numeroSafe}')">Ver</button>`
									: `<button class="btn-ocupar-mesa" onclick="ocuparMesa(${mesa.id})">Ocupar</button>`
							}
                            <button class="btn-editar-mesa" onclick="editarMesa(${mesa.id})">✏️</button>
                            <button class="btn-eliminar-mesa" onclick="eliminarMesa(${mesa.id})">🗑️</button>
                        </div>
                    </div>
                `;
		});

		mesasGrid.html(html);
	};

	win.abrirModalCrearMesa = function abrirModalCrearMesa() {
		$('#mesa-id').val('');
		$('#mesa-numero').val('');
		$('#mesa-nombre').val('');
		$('#mesa-capacidad').val(4);
		$('#modal-mesa-titulo').text('Nueva Mesa');
		const modal = $('#modal-mesa');
		if (!modal.length) {
			win.mostrarNotificacion('Error: Modal no encontrado', 'error');
			return;
		}
		modal.attr('style', 'display: flex !important;').addClass('show');
	};

	win.editarMesa = function editarMesa(id) {
		const mesa = (win.mesasData || []).find((m) => m.id == id);
		if (!mesa) return;

		$('#mesa-id').val(mesa.id);
		$('#mesa-numero').val(mesa.numero);
		$('#mesa-nombre').val(mesa.nombre || '');
		$('#mesa-capacidad').val(mesa.capacidad);
		$('#modal-mesa-titulo').text('Editar Mesa');
		$('#modal-mesa').show();
	};

	win.cerrarModalMesa = function cerrarModalMesa() {
		$('#modal-mesa').removeClass('show').attr('style', 'display: none !important;');
		const form = $('#form-mesa')[0];
		if (form) form.reset();
	};

	win.ocuparMesa = function ocuparMesa(id) {
		if (!confirm('¿Deseas ocupar esta mesa?')) return;

		$.ajax({
			url: posknMesasAdminAjaxUrl(win),
			type: 'POST',
			data: {
				action: 'poskn_ocupar_mesa',
				nonce: posknMesasAdminNonce(win),
				id,
				tienda_id: posknMesasTiendaId(win),
			},
			success(response) {
				if (response.success) {
					win.mostrarNotificacion(response.data.message, 'success');
					win.cargarMesas();
				} else {
					win.mostrarNotificacion(response.data.message, 'error');
				}
			},
		});
	};

	win.cerrarModalProductosMesa = function cerrarModalProductosMesa() {
		$('#modal-productos-mesa').removeClass('show').attr('style', 'display: none !important;');
	};

	win.verProductosMesa = function verProductosMesa(mesaId, orderId, mesaNumero) {
		const titulo = `Productos - Mesa ${mesaNumero || mesaId}`;
		$('#modal-productos-mesa-titulo').text(titulo);
		$('#modal-productos-mesa-body').html('<p style="color:#666;">Cargando...</p>');
		$('#modal-productos-mesa').attr('style', 'display: flex !important;').addClass('show');

		if (!orderId) {
			$('#modal-productos-mesa-body').html(
				'<p style="color:#999;">No hay pedido asociado a esta mesa.</p>',
			);
			return;
		}

		$.post(posknMesasAdminAjaxUrl(win), {
			action: 'poskn_get_order_items',
			nonce: posknMesasAdminNonce(win),
			order_id: orderId,
		})
			.done((r) => {
				if (r && r.success && r.data && r.data.items) {
					const items = r.data.items;
					if (!items.length) {
						$('#modal-productos-mesa-body').html(
							'<p style="color:#999;">No hay productos en este pedido.</p>',
						);
						return;
					}
					let html = '<ul style="list-style:none; padding:0; margin:0;">';
					items.forEach((it) => {
						const name = String(it.name || '').replace(/</g, '&lt;');
						const qty = parseFloat(it.quantity) || 1;
						const notes = String(it.notes || '').replace(/</g, '&lt;');
						html +=
							'<li style="padding:8px 0; border-bottom:1px solid #eee; display:flex; justify-content:space-between; align-items:center;">';
						html += `<span><strong>${name}</strong> × ${qty}${notes ? ` <small style="color:#666;">(${notes})</small>` : ''}</span>`;
						html += '</li>';
					});
					html += '</ul>';
					$('#modal-productos-mesa-body').html(html);
				} else {
					$('#modal-productos-mesa-body').html(
						'<p style="color:#c62828;">No se pudieron cargar los productos.</p>',
					);
				}
			})
			.fail((xhr) => {
				let msg = 'No se pudo cargar el pedido.';
				try {
					const parsed = xhr && xhr.responseJSON;
					if (parsed && parsed.data) {
						msg = typeof parsed.data === 'string' ? parsed.data : (parsed.data.message || msg);
					}
				} catch (e) {
					/* ignore */
				}
				$('#modal-productos-mesa-body').html(
					`<p style="color:#c62828;">${String(msg).replace(/</g, '&lt;')}</p>`,
				);
			});
	};

	win.eliminarMesa = function eliminarMesa(id) {
		if (!confirm('¿Estás seguro de eliminar esta mesa?')) return;

		$.ajax({
			url: posknMesasAdminAjaxUrl(win),
			type: 'POST',
			data: {
				action: 'poskn_eliminar_mesa',
				nonce: posknMesasAdminNonce(win),
				id,
				tienda_id: posknMesasTiendaId(win),
			},
			success(response) {
				if (response.success) {
					win.mostrarNotificacion(response.data.message, 'success');
					win.cargarMesas();
				} else {
					win.mostrarNotificacion(response.data.message, 'error');
				}
			},
		});
	};

	win.mostrarModuloMesas = function mostrarModuloMesas() {
		if (typeof win.posknPuedeVerMesas !== 'undefined' && !win.posknPuedeVerMesas) return;
		$('.pos-container').hide();
		$('.modulo-contenido').hide();
		$('#modulo-mesas').show();
		win.cargarMesas();
	};
}
